import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class VehicleType extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps} title={this.props.dataItem.VehicleDescription}>
        {this.props.dataItem.VehicleType}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}
